import PersonIcon from '@mui/icons-material/PersonOutlineRounded';
import CodeIcon from '@mui/icons-material/CodeRounded';
import LockIcon from '@mui/icons-material/LockOutlined';
import MailIcon from '@mui/icons-material/AlternateEmailRounded';

export function LanguageSelector({checked, setChecked, compact = false}) {
    const languages = [
        {code: 'EN', checked: false, label: 'Switch to English'},
        {code: 'IT', checked: true, label: "Passa all'italiano"},
    ];

    return (
        <div
            role="group"
            aria-label="Language selector"
            className={`lang ${compact ? 'lang--compact' : ''}`}
        >
            <span
                aria-hidden="true"
                className="lang__thumb"
                data-selected-language={checked ? 'it' : 'en'}
                style={{ transform: `translateX(${checked ? 100 : 0}%)` }}
            />
            {languages.map((language) => {
                const isSelected = checked === language.checked;
                return (
                    <button
                        type="button"
                        key={language.code}
                        className={`lang__option ${isSelected ? 'is-selected' : ''}`}
                        onClick={() => setChecked(language.checked)}
                        aria-label={language.label}
                        aria-pressed={isSelected}
                    >
                        {language.code}
                    </button>
                );
            })}
        </div>
    );
}

export const buildNavItems = (checked, projectsUrl) => [
    { id: 'about', href: '#/', label: checked ? 'Chi Sono' : 'About', icon: PersonIcon },
    { id: 'projects', href: projectsUrl, label: checked ? 'Progetti' : 'Projects', icon: CodeIcon },
    { id: 'work', href: '#/work', label: 'Closed', icon: LockIcon },
    { id: 'contacts', href: '#/contacts', label: checked ? 'Contatti' : 'Contacts', icon: MailIcon },
];

function NavLinks({items, selectedId, onNavigate, variant}) {
    const selectedIndex = Math.max(0, items.findIndex((item) => item.id === selectedId));
    return (
        <div className={`nav-links nav-links--${variant}`}>
            <span
                aria-hidden="true"
                className="nav-links__thumb"
                data-active-index={selectedIndex}
                style={{
                    width: `calc((100% - 8px) / ${items.length})`,
                    transform: `translateX(${selectedIndex * 100}%)`,
                }}
            />
            {items.map((item) => {
                const NavIcon = item.icon;
                const isSelected = selectedId === item.id;
                return (
                    <a
                        key={item.id}
                        href={item.href}
                        className={`nav-links__item ${isSelected ? 'is-selected' : ''}`}
                        onClick={(event) => onNavigate(event, item.id)}
                        aria-current={isSelected ? 'page' : undefined}
                    >
                        <NavIcon className="nav-links__icon" />
                        <span>{item.label}</span>
                    </a>
                );
            })}
        </div>
    );
}

function Navbar({checked, setChecked, items, selectedId, onNavigate, scrolled}) {
    return (
        <>
            <header className={`topbar ${scrolled ? 'is-scrolled' : ''}`}>
                <a
                    href="#/"
                    className="topbar__brand"
                    onClick={(event) => onNavigate(event, 'about')}
                    aria-label="Flavio Ceccarelli"
                >
                    <span className="topbar__logo">FC</span>
                    <span className="topbar__name">Flavio Ceccarelli</span>
                </a>

                <nav
                    className="topbar__nav"
                    aria-label={checked ? 'Navigazione desktop' : 'Desktop navigation'}
                >
                    <NavLinks items={items} selectedId={selectedId} onNavigate={onNavigate} variant="desktop" />
                </nav>

                <div className="topbar__lang topbar__lang--desktop">
                    <LanguageSelector checked={checked} setChecked={setChecked} />
                </div>
            </header>

            <div className="topbar__lang topbar__lang--mobile">
                <LanguageSelector checked={checked} setChecked={setChecked} compact />
            </div>

            <nav
                className="bottombar"
                aria-label={checked ? 'Navigazione principale' : 'Primary navigation'}
            >
                <NavLinks items={items} selectedId={selectedId} onNavigate={onNavigate} variant="mobile" />
            </nav>
        </>
    );
}

export default Navbar;
